import React, { Component, Fragment } from "react";
import { Route } from "react-router";
import { Login } from "./Login";
import { Logout } from "./Logout";
import { ApplicationPaths, LoginActions, LogoutActions } from "./ApiAuthorizationConstants";

export default class ApiAuthorizationRoutes extends Component {
  render() {
    return (
      <Fragment>
        <Route path={ApplicationPaths.Login} render={() => <Login action={LoginActions.Login} />} />
        <Route path={ApplicationPaths.LoginFailed} render={() => <Login action={LoginActions.LoginFailed} />} />
        <Route path={ApplicationPaths.LoginCallback} render={() => <Login action={LoginActions.LoginCallback} />} />
        <Route path={ApplicationPaths.Profile} render={() => <Login action={LoginActions.Profile} />} />
        <Route path={ApplicationPaths.Register} render={() => <Login action={LoginActions.Register} />} />
        <Route path={ApplicationPaths.LogOut} render={() => <Logout action={LogoutActions.Logout} />} />
        <Route path={ApplicationPaths.LogOutCallback} render={() => <Logout action={LogoutActions.LogoutCallback} />} />
        <Route path={ApplicationPaths.LoggedOut} render={() => <Logout action={LogoutActions.LoggedOut} />} />
      </Fragment>
    );
  }
}
